import moment from 'moment/moment';
import React, { useState } from "react";
import DatePicker from "react-datepicker";

import "./dateRangeFilterInput.css";

const DateRangeFilterInput = ({ label, onChange, defaultStartDate, defaultEndDate}) => { 
    const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]);
    const [startDate, endDate] = dateRange;
    
    return (
        <div>
            {label}:&nbsp;
            <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                    setDateRange(update);
                    onChange(...update);
                }}
                placeholderText="MM/DD/YYYY - MM/DD/YYYY"
            />
        </div>
        
    );
}


export default DateRangeFilterInput;
